export default __webpack_public_path__ + "static/media/NAIYC.772e2d8a.jpg";